import {Component, forwardRef, Input, OnChanges, OnInit} from '@angular/core';
import {UploadService} from './upload.service';
import {FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import AppConstants, {file_upload_error} from '../../shared/common-components/AppConstants';
import {AlertService} from '../../services/alert/alert.service';
import {BehaviorSubject, timer} from 'rxjs';
import {takeWhile} from 'rxjs/operators';
import {UserService} from '../../services/user/user.service';
import {Router} from '@angular/router';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {CommonModule, NgFor, NgIf} from "@angular/common";
import {XtosShipmentComponent} from "../xtos-reporting/xtos-shipment/xtos-shipment.component";

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.css'],
    imports: [
        ReactiveFormsModule, NgIf, CommonModule]
})
export class UploadComponent implements OnInit,OnChanges {

  /*
   send business type from the input valid business types are  "hhg"; "frt"; "shipment"; "survey"; "iff";
  */
  @Input() businessType;
  @Input() userPermission;
  @Input() isChild;
  file: File = null;
  messageValue: any = '';
  fileUpload = {status: '', message: this.messageValue};
  uploadForm: FormGroup;
  showDownload: boolean;
  private maxFileSizeInBytes: number = 1073741824 * 3; // 1.07*10^9 bytes in a gigabyte, times 3 = 3 gigabytes
  uploadTitle: any;
  observer$ = new BehaviorSubject(true);
  isRateFilingClosed$ = new BehaviorSubject(false);
  // fileError = null;

  constructor(private uploadService: UploadService, private userService: UserService, private router: Router,
              private fb: FormBuilder, private alertService: AlertService) {
    this.uploadForm = this.fb.group({
      filePicker: new FormControl('', Validators.required)
    });
  }

  /**
   * @description evaluated component title based on the businessType
   */
  ngOnInit() {
    timer(1000, 1000)
      .pipe(takeWhile(() => !this.isRateFilingClosed$.value))
      .subscribe(val => {
        this.userService.isRateFilingClosed()
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(res => {
            this.isRateFilingClosed$.next(res);
            if (res) {
              this.alertService.warn('Rate Filing Window has been closed!');
              this.router.navigate(['/', 'landing']);
            }
          });
      });
  }
  ngOnChanges(){
    switch (this.businessType) {
      case "iffFRT":
        this.businessType = "iff";
        this.uploadTitle = "Upload Shipment Reports";
        this.showDownload = false;
        break;
      case "iffHHG":
        this.businessType = "iff";
        this.uploadTitle = "Upload HHG/SIT Shipment Reports";
        this.showDownload = false;
        break;
      case "xtosHHG":
        this.businessType = "XTOS";
        this.uploadTitle = "Upload Shipment/XTOS Reports";
        this.showDownload = false;
        break;
      case "survey":
        this.uploadTitle = "Upload GSA 3080";
        this.showDownload = false;
        break;
      case "shipment":
        this.uploadTitle = "Shipment Delivery Report Upload";
        this.showDownload = true;
        break;
      case "hhg":
      case "frt":
        this.uploadTitle = "Upload Rate File";
        this.showDownload = false;
        break;
      default:
        this.uploadTitle = "";
        this.showDownload = false;
        break;
    }
  }

  /**
   * @description reads the uploaded file as a stream and processes it.
   * @param e
   */
  fInput(e) {
    this.file = e.target.files[0] ? e.target.files[0] : null;
    /*TODO file validation*/
/*    if (this.businessType === 'frt') {
      const frtFileExtensions = [
        'Linehaul_TL', 'Accessorials_TL', 'Linehaul_LTL', 'Accessorials_LTL', 'Linehaul_FLV', 'Linehaul_FLV Domestic 1', 'Linehaul_FLV Domestic 2',
        'Linehaul_FLV Domestic 3', 'Linehaul_FLV International 1', 'Linehaul_FLV International 2', 'Linehaul_FLV International 3'

      ];
      this.fileError = frtFileExtensions.indexOf(this.file.name.substr(0, this.file.name.indexOf('.'))) > -1 ? null : 'Invalid File Name.';
    }*/
    // if (this.file !== null && !this.fileError) {
    if (this.file !== null) {
      if (this.file.size && this.file.size > this.maxFileSizeInBytes) {
        this.fileUpload = {status: 'error', message: 'You have selected a file larger than the max file size (3GB)'};
      } else if (this.file.size && this.file.size > 0) {
        this.fileUpload = {status: 'ok', message: ''};
      } else {
        this.fileUpload = {status: 'error', message: ''};
      }
      const f: string[] = this.file.name.split('.');
      let ext = '';
      if (f.length > 1) {
        ext = f[f.length - 1];
      }
      if (ext !== 'xlsx') {
        this.fileUpload = {status: 'error', message: file_upload_error};
      }
    } else {
      this.fileUpload = {status: '', message: ''};
    }


  }

  /**
   * @description service to send the uploaded file and handles the not null condition of the file and error.
   */
  upload() {
    if (AppConstants.isNotNullCondition(this.fileUpload.message) && this.fileUpload.message === file_upload_error) {
      this.alertService.info(file_upload_error);
      return;
    }
    if (AppConstants.isNotNullCondition(this.file)) {
      this.uploadService.postFile(this.file, this.businessType).subscribe({
        next: (result) => {
          this.fileUpload = result;
          setTimeout(() => {
            this.file = null;
            this.uploadForm.get('filePicker').setValue('');
            this.uploadForm.get('filePicker').setValidators([Validators.required]);
          }, 2500);
        },
        error: (error) => {this.fileUpload = {status: 'error', message: error.name + ': ' + error.message};}
      });
    } else {
      this.alertService.info('please select a file before upload!');
    }
  }

}
